import { useQuery, UseQueryResult } from 'react-query';
import { FileRetrieve } from 'types';
import { client } from 'utils/api-client';

function useAthleteFile(fileId: string | undefined): UseQueryResult<{ data: FileRetrieve }> {
  return useQuery(['files', fileId], () => client.get(`files/${fileId}/`), {
    enabled: !!fileId,
  });
}

export default useAthleteFile;
